import { LeftOutlined } from '@ant-design/icons'
import { Button, Flex } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'

import { useSimeTbServiceGetSimeTbTreatmentPlanEndpoint } from 'src/api/queries'
import { LoadingScreen } from 'src/components'
import { useLocales } from 'src/locales'

import { SimeTBTreatmentBody } from './SimeTBTreatmentBody'
import { SimeTBTreatmentHeader } from './SimeTBTreatmentHeader'

export const SimeTBDetailsDetails = () => {
  const { id } = useParams()
  const navigate = useNavigate()

  const { t } = useLocales()

  const { data, isLoading } = useSimeTbServiceGetSimeTbTreatmentPlanEndpoint(
    {
      id: String(id)
    },
    [String(id)],
    { enabled: !!id }
  )

  const onBackClick = () => {
    navigate(-1)
  }

  if (isLoading) {
    return <LoadingScreen />
  }

  return (
    <Flex vertical gap={24}>
      <Button
        icon={<LeftOutlined />}
        className="fit-content"
        onClick={onBackClick}
      >
        {t('common.back')}
      </Button>
      <Flex vertical gap={16}>
        <SimeTBTreatmentHeader data={data} />
        <SimeTBTreatmentBody data={data} />
      </Flex>
    </Flex>
  )
}
